import React from 'react';
import './PrivacyTerms.css'; // Import the CSS file

const Terms = () => {
  return (
    <>
    <div className="policy-container">
      <h1>Terms & Conditions</h1>
      <p>Last updated: March 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to Privofy. By using our website, you agree to these Terms & Conditions. 
        If you do not agree, please do not use our services.
      </p>

      <h2>2. Use of the Service</h2>
      <p>
        You must be at least 13 years old to use our website. You agree not to misuse our platform 
        for illegal or unauthorized activities.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        You are responsible for maintaining the security of your account. We reserve the right 
        to suspend or terminate accounts that violate these terms.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content on Privofy, including logos, trademarks, and software, is our property. You 
        may not copy, modify, or distribute any content without permission.
      </p>

      <h2>5. Disclaimer of Warranties</h2>
      <p>
        Our service is provided "as is" without any warranties. We are not responsible for any 
        inaccuracies, errors, or data loss.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        We are not liable for any damages resulting from the use of our platform. This includes 
        indirect, incidental, or consequential damages.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may update these terms at any time. Continued use of our service constitutes acceptance 
        of the revised terms.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions about these terms, contact us at 
        <a href="mailto:support@privofy.com">support@privofy.com</a>.
      </p>
    </div>
    </>
  );
};

export default Terms;


